import { ApiResponse } from './types'

export enum UserProductStates {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  PENDING_CANCEL = 'PENDING_CANCEL',
  PENDING_ACTIVE = 'PENDING_ACTIVE',
  PENDING_CHANGE = 'PENDING_CHANGE',
  PAYMENT_FAIL = 'PAYMENT_FAIL',
  PAYMENT_FAIL_AUTH = 'PAYMENT_FAIL_AUTH',
}

export enum TypeOfPaymentRecurrence {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  THREE_MONTHLY = 'THREE_MONTHLY',
  SIX_MONTHLY = 'SIX_MONTHLY',
  YEARLY = 'YEARLY',
}

export type UserProduct = {
  externalId: string
  state: UserProductStates
  validUntil?: Date
}

type PurchaseType = 'subscription' | 'oneshot'

export type FuturePurchase = {
  validFrom: Date
  productId: string
}

export type CurrentProductFromCustomer = {
  currentPurchases: CustomerProduct[]
  futurePurchases: FuturePurchase[]
}

export type CustomerProduct = {
  platform: string
  purchaseType: PurchaseType
  productId: string
  platformPurchaseId: string
  academy: string
  validFrom: Date
  validTo?: Date
  status: UserProductStates
  renewDate: Date
  nextPaymentAttempt?: Date
  paymentIntent: string
}

type AdditionalProduct = {
  description: string
  type: string
  style?: string
}

export type Product = {
  id: number
  title: string
  isCurrentProduct: boolean
  isBestProduct: boolean
  monthlyPayment: number
  savingAmount: number
  state?: UserProductStates
  validUntil?: Date
  validFrom?: Date
  renewDate?: Date
  nextPaymentAttempt?: Date
  paymentIntent?: string
  isBetterProductThanActual: boolean
  additionalProduct: AdditionalProduct[]
  purchaseId?: string
  amount: number
  paymentPeriodicity: TypeOfPaymentRecurrence
  canCancelPlan: boolean
  canSwitchPlan: boolean
  order: number
  listContentColor?: string
  listBackgroundColor?: string
  upsellingButtonContent?: string
  canBeBestPriceOnList: boolean
}

export type BillingItem = {
  amount: number
  description: string
}
export type BillingNext = {
  items: BillingItem[]
  nextBillingDate?: Date
  amount?: number
  discount?: number
  balance?: number
}

export type ProductApiResponse = ApiResponse & {
  content?: Product[][]
  billing?: BillingNext
}

//export type Products = Product[]
